/**
 * Timezone and Date Utility Functions
 * Used to ensure consistent date handling across the application
 */

// Format a date object to YYYY-MM-DD string in LOCAL timezone
export const toLocalDateString = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

// Create a date object set to NOON (12:00:00) in local timezone
// Useful for creating dates that are safe from minor timezone shifts when converting to UTC
export const getLocalNoonDate = (date) => {
    const d = new Date(date);
    d.setHours(12, 0, 0, 0);
    return d;
};

// Check if two dates represent the same local day
export const isSameLocalDay = (date1, date2) => {
    return toLocalDateString(date1) === toLocalDateString(date2);
};

// Get a date objects for a range of days
export const getDateRange = (startDate, daysCount) => {
    const dates = [];
    const current = new Date(startDate);

    for (let i = 0; i < daysCount; i++) {
        dates.push(new Date(current));
        current.setDate(current.getDate() + 1);
    }

    return dates;
};
